import { NgModule } from '@angular/core';

import { SelectboxLabelModule } from './selectbox-label/selectbox-label.module';

@NgModule({
    exports: [SelectboxLabelModule],
})
export class SelectboxsComponentsModule {}
